module.exports = __webpack_public_path__ + "img/Dinner_l.58b04200.svg";